/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 * Auth ServiceAccess constants
 *
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.11.0
 */

/*
 * -------------------------------------------
 *         Логин Пользователя как СП
 * -------------------------------------------
 */

export const LOGIN_PROCESS_SERVICE_ACCESS = '@@b2b_portal_ui/authorization/LOGIN_PROCESS_SERVICE_ACCESS';
export const LOGIN_PROCESS_SERVICE_ACCESS_SUCCESSFUL =
    '@@b2b_portal_ui/authorization/LOGIN_PROCESS_SERVICE_ACCESS_SUCCESSFUL';
export const LOGIN_PROCESS_SERVICE_ACCESS_ERROR = '@@b2b_portal_ui/authorization/LOGIN_PROCESS_SERVICE_ACCESS_ERROR';

/*
 * -------------------------------------------
 *         Логин Пользователя как СП для новостей
 * -------------------------------------------
 */

export const LOGIN_PROCESS_NEWS_SERVICE_ACCESS_SUCCESSFUL =
    '@@b2b_portal_ui/authorization/LOGIN_PROCESS_NEWS_SERVICE_ACCESS_SUCCESSFUL';
export const LOGIN_PROCESS_NEWS_SERVICE_ACCESS_ERROR =
    '@@b2b_portal_ui/authorization/LOGIN_PROCESS_NEWS_SERVICE_ACCESS_ERROR';

/*
 * -------------------------------------------
 *     Логин СП Пользователя как абонента
 * -------------------------------------------
 */

export const LOGIN_USER_SERVICE_ACCESS = '@@b2b_portal_ui/authorization/LOGIN_USER_SERVICE_ACCESS';

/*
 * -------------------------------------------
 *   Сменить пользователя (сессия СП остается)
 * -------------------------------------------
 */

export const CHANGE_USER_SERVICE_ACCESS = '@@b2b_portal_ui/authorization/CHANGE_USER_SERVICE_ACCESS';
